(function () {
 if (window.__oscoButtonsInit) return;
 window.__oscoButtonsInit = true;


 function equalize(container) {
   if (!container) return;


   // Only equalize when 2 buttons exist
   const btns = container.querySelectorAll('[data-osco-btn]');
   if (btns.length !== 2) return;


   // Reset first (so shrink works when editing labels)
   btns.forEach(b => (b.style.minWidth = ''));


   // Measure widths
   let max = 0;
   btns.forEach(b => {
     const w = Math.ceil(b.getBoundingClientRect().width);
     if (w > max) max = w;
   });


   // Apply equal width
   btns.forEach(b => (b.style.minWidth = max + 'px'));
 }


 function runAll() {
   document.querySelectorAll('[data-osco-buttons]').forEach(equalize);
 }


 // Run on DOM ready and also on load (covers fonts/layout settling)
 document.addEventListener('DOMContentLoaded', runAll);
 window.addEventListener('load', runAll);


 // Re-run on resize
 window.addEventListener('resize', runAll);


 // Shopify Theme Editor events
 document.addEventListener('shopify:section:load', runAll);
 document.addEventListener('shopify:section:select', runAll);
 document.addEventListener('shopify:block:select', runAll);
})();
